import { z } from 'zod'
import {
  EMAIL_REQUIRED_MESSAGE,
  EMAIL_INVALID_MESSAGE,
  PASSWORD_REQUIRED_MESSAGE,
  PASSWORD_MIN_LENGTH_MESSAGE,
  NEW_PASSWORD_REQUIRED_MESSAGE,
  CONFIRM_PASSWORD_REQUIRED_MESSAGE,
  PASSWORD_MISMATCH_MESSAGE,
} from '../constants/validationMessages'

const emailSchema = z
  .string()
  .min(1, EMAIL_REQUIRED_MESSAGE)
  .email(EMAIL_INVALID_MESSAGE)

export const loginFormSchema = z.object({
  email: emailSchema,
  password: z
    .string()
    .min(1, PASSWORD_REQUIRED_MESSAGE)
    .min(6, PASSWORD_MIN_LENGTH_MESSAGE),
})

export type LoginFormValues = z.infer<typeof loginFormSchema>

export const forgotPasswordFormSchema = z.object({
  email: emailSchema,
})

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordFormSchema>

export const resetPasswordFormSchema = z
  .object({
    new_password: z.string().min(1, NEW_PASSWORD_REQUIRED_MESSAGE),
    confirm_password: z.string().min(1, CONFIRM_PASSWORD_REQUIRED_MESSAGE),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    path: ['confirm_password'],
    message: PASSWORD_MISMATCH_MESSAGE,
  })

export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>

export const registerSignupFormSchema = z
  .object({
    first_name: z.string().min(1, 'First name is required.'),
    last_name: z.string().min(1, 'Last name is required.'),
    email: emailSchema,
    confirm_email: emailSchema,
    mobile_no: z.string().min(1, 'Phone number is required.'),
    password: z
      .string()
      .min(1, PASSWORD_REQUIRED_MESSAGE)
      .min(6, PASSWORD_MIN_LENGTH_MESSAGE),
    confirm_password: z.string().min(1, CONFIRM_PASSWORD_REQUIRED_MESSAGE),
  })
  .refine((data) => data.email === data.confirm_email, {
    path: ['confirm_email'],
    message: 'Email addresses do not match.',
  })
  .refine((data) => data.password === data.confirm_password, {
    path: ['confirm_password'],
    message: PASSWORD_MISMATCH_MESSAGE,
  })

export type RegisterSignupFormValues = z.infer<typeof registerSignupFormSchema>
